// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"move-1"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M18.5 15L21.5 12L18.5 9M5.5 8.99999L2.5 12L5.5 15M15 5.5L12 2.5L9 5.5M9 18.5L12 21.5L15 18.5M12 3.75V12M12 12V20.25M12 12L20.25 12M12 12L3.75 12","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-move-1')
export default class Move1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'move-1',
    }
  }
}
